export default {
  currentPrizeType: null,
  defaultSort: null,

  fetchingWinners: false,
  currentExpandedRow: null,

  currentWinnerId: null,

  searchResults: null,

  isEditWinnerStoryModalOpen: false,
  winnerStorySaveError: false,
  savingWinnerStory: false,

  dateOrderedPendingSaves: [],
  dateOrderedSaveSuccesses: [],
  dateOrderedSaveErrors: [],

  editingWinnerNotes: null,
  notesPendingSaves: [],
  notesSaveSuccesses: [],
  notesSaveErrors: [],

  featuredWinnerPendingSaves: [],
  featuredWinnerSaveSuccesses: [],
  featuredWinnerSaveErrors: [],
  isFeaturedErrorModalOpen: false,
  featuredErrorModalLang: null,

  publishingFeaturedWinners: false,
  isPublishFeaturedErrorModalOpen: false
};



// WEBPACK FOOTER //
// ./public/pages/ListWinners/initialState.js